module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAAAAABWESUoAAAAF0lEQVQ4y2OUZsAPGEcVjCoYVTBSFQAAcukDgVSjj4YAAAAASUVORK5CYII="